import axios from 'axios'
import { useBoolean } from '@rothzerg/useboolean'
import { isEmail, isEmpty } from '@rothzerg/validator'
import React, { useState, useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import FormInput from '../ui/Form/FormInput'
import FormSelect from '../ui/Form/FormSelect'
import SVG from '../ui/SVG/SVG'

const SmallBusinessForm = props => {
  const { body, subbody, ...rest } = props

  const [formSubmitting, setFormSubmitting] = useBoolean()
  const [email, setEmail] = useState('')
  const [title, settitle] = useState('')
  const [name, setname] = useState('')
  const [businessname, setbusinessname] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [abn, setabn] = useState('')
  const [packageSelect, setpackageSelect] = useState('')
  const [needVehicles, setneedVehicles] = useState('')
  const [spendingannum, setspendingannum] = useState('')
  const [contactby, setcontactby] = useState('')
  const [businessaddress, setbusinessaddress] = useState('')

  const [businessaddressError, setbusinessaddressError] = useState(undefined)
  const [abnError, setAbnError] = useState(undefined)
  const [emailError, setEmailError] = useState(undefined)
  const [nameError, setnameError] = useState(undefined)
  const [businessnameError, setbusinessnameError] = useState(undefined)
  const [titleError, settitleError] = useState(undefined)
  const [phoneNumberError, setPhoneNumberError] = useState(undefined)
  const [formStatus, setFormStatus] = useState(null)
  const [bizNum, setBizNum] = useState('')

  const [packageSelectError, setpackageSelectError] = useState(undefined)
  const [needVehiclesError, setneedVehiclesError] = useState(undefined)
  const [spendingannumError, setspendingannumError] = useState(undefined)
  const [contactbyError, setcontactbyError] = useState(undefined)

  const submitForm = () => {
    let error = false
    setEmailError(undefined)
    setAbnError(undefined)
    setnameError(undefined)
    setbusinessnameError(undefined)
    settitleError(undefined)
    setPhoneNumberError(undefined)
    setbusinessaddressError(undefined)
    setpackageSelectError(undefined)
    setneedVehiclesError(undefined)
    setspendingannumError(undefined)
    setcontactbyError(undefined)

    if (isEmpty(packageSelect) && rest.disablePackage === '0') {
      setpackageSelectError(['Please select the package'])
      error = true
    }
    if (isEmpty(needVehicles) && rest.disableVehiclesType === '0') {
      setneedVehiclesError(['Please select where you need vehicles'])
      error = true
    }
    if (isEmpty(spendingannum) && rest.disableSpendingAnnum === '0') {
      setspendingannumError(['Please select your estimated spend on rental vehicles per annum'])
      error = true
    }
    if (isEmpty(contactby) && rest.disableContactBy === '0') {
      setcontactbyError(['Please select contact method'])
      error = true
    }
    if (!isEmail(email) && rest.disableEmail === '0') {
      setEmailError(['Please enter a valid email address'])
      error = true
    }
    if (isEmpty(abn) && rest.disableAbn === '0') {
      setAbnError([`Please enter your ${bizNum}`])
      error = true
    }
    if (isEmpty(name) && rest.disableName === '0') {
      setnameError(['Please enter your full name'])
      error = true
    }
    if (isEmpty(businessname) && rest.disableBusinessName === '0') {
      setbusinessnameError(['Please enter your business name'])
      error = true
    }
    if (isEmpty(title) && rest.disableTitle === '0') {
      settitleError(['Please enter your title'])
      error = true
    }
    if (isEmpty(phoneNumber) && rest.disablePhoneNumber === '0') {
      setPhoneNumberError(['Please enter your phone number'])
      error = true
    }
    if (isEmpty(businessaddress) && rest.disableBusinessAddress === '0') {
      setbusinessaddressError(['Please enter your business postal address'])
      error = true
    }

    if (!error) {
      setFormSubmitting.true()
      const params = new URLSearchParams()
      if (rest.disableTitle === '0') params.append('title', title)
      if (rest.disableEmail === '0') params.append('email', email)
      if (rest.disableName === '0') params.append('name', name)
      if (rest.disableBusinessName === '0') params.append('businessname', businessname)
      if (rest.disableBusinessAddress === '0') params.append('businessaddress', businessaddress)
      if (rest.disableAbn === '0') params.append('abn', abn)
      if (rest.disablePhoneNumber === '0') params.append('phoneNumber', phoneNumber)
      if (rest.disablePackage === '0') params.append('packageSelect', packageSelect)
      if (rest.disableVehiclesType === '0') params.append('needVehicles', needVehicles)
      if (rest.disableSpendingAnnum === '0') params.append('spendingannum', spendingannum)
      if (rest.disableContactBy === '0') params.append('contactby', contactby)
      params.append('gonder', rest.sendEmailTo)

      axios
        .post('/api/smallbusinessform', params)
        .then(({ data }) => {
          setFormSubmitting.false()
          setFormStatus(data.status)
        })
        .catch(err => {
          console.error(err)
        })
    }
  }

  const useStyles = createUseStyles(theme => ({
    container: { padding: '30px 15px' },
    innerCont: { margin: '0 auto', width: '100%', maxWidth: '1220px' },
    title: {
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 700,
      fontFamily: 'TTRounds',
      textAlign: 'left',
      marginBottom: '15px',
      marginTop: 0,
      color: theme.colors.main,
    },
    details: {
      fontSize: '30px',
      lineHeight: '26px',
      fontWeight: 400,
      textAlign: 'left',
      marginBottom: '15px',
      marginTop: 0,
      maxWidth: '560px',
      '@media (max-width: 600px)': {
        fontSize: '25px',
        lineHeight: 1.4,
      },
    },
    subdetails: {
      fontSize: '18px',
      lineHeight: '26px',
      fontWeight: 300,
      textAlign: 'left',
      marginBottom: '30px',
      marginTop: 0,
      maxWidth: '560px',
      '@media (max-width: 600px)': {
        fontSize: '15px',
        lineHeight: 1.4,
      },
    },
    flexCont: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 20,
      '@media (max-width: 600px)': {
        gridTemplateColumns: '1fr',
        gap: 0,
      },
    },
    flexContFull: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: 20,
    },
    formsec: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      '@media (max-width: 600px)': {
        flexDirection: 'column',
      },
    },
    formarea: {
      width: '100%',
      maxWidth: 700,
    },
    tollarea: {
      width: 380,
      borderRadius: 20,
      backgroundColor: '#F5F5F5',
      padding: 40,
      boxSizing: 'border-box',
      '@media (max-width: 600px)': {
        width: '100%',
        marginTop: 60,
      },
    },
    tollareaTitle: {
      color: theme.colors.main,
      fontSize: 18,
      lineHeight: 1.3,
      marginBottom: 20,
    },
    tollareaNumber: {
      color: '#2D2D2D',
      fontSize: 15,
      lineHeight: 1.3,
      marginBottom: 10,
      '& a': {
        color: theme.colors.main,
      },
      '& span': {
        '&:nth-child(2)': {
          marginLeft: 3,
        },
      },
    },
    buttonPrimary: {
      display: 'inline-block',
      padding: '14px 0',
      border: 'none',
      color: '#fff',
      backgroundColor: theme.colors.orange,
      borderRadius: '15px',
      lineHeight: '18px',
      fontSize: '18px',
      fontWeight: 700,
      textDecoration: 'none',
      width: 215,
      '@media (max-width: 600px)': {
        display: 'block',
        width: '100%',
      },
      '&:hover': {
        backgroundColor: theme.colors.orangeHover,
        cursor: 'pointer',
      },
    },
  }))

  const classes = useStyles()

  useEffect(() => {
    if (window.location.hostname.includes('.nz')) {
      setBizNum('NZBN')
    } else {
      setBizNum('ACN/ABN')
    }
  }, [])

  return (
    <div className={classes.container}>
      <div className={classes.innerCont}>
        <div className={classes.formsec}>
          <div className={classes.formarea}>
            {body !== '' && <div className={classes.details}>{body}</div>}
            {subbody !== '' && <div className={classes.subdetails}>{subbody}</div>}
            <div className={classes.form}>
              <h2>Your details</h2>
              <div className={classes.flexCont}>
                {rest.disableTitle === '0' && (
                  <div>
                    <FormInput
                      greyBackground={true}
                      disabled={formSubmitting}
                      error={titleError}
                      labelText="Title/Position*"
                      inputType="text"
                      defaultValue=""
                      onChange={el => {
                        settitle(el.currentTarget.value)
                      }}
                    />
                  </div>
                )}
                {rest.disableName === '0' && (
                  <div>
                    <FormInput
                      greyBackground={true}
                      disabled={formSubmitting}
                      error={nameError}
                      labelText="Full Name*"
                      inputType="text"
                      defaultValue=""
                      onChange={el => {
                        setname(el.currentTarget.value)
                      }}
                    />
                  </div>
                )}
              </div>
              <div className={classes.flexCont}>
                {rest.disableEmail === '0' && (
                  <div>
                    <FormInput
                      disabled={formSubmitting}
                      greyBackground={true}
                      labelText="Email Address*"
                      inputType="email"
                      defaultValue=""
                      error={emailError}
                      onChange={el => {
                        setEmail(el.currentTarget.value)
                      }}
                    />
                  </div>
                )}

                {rest.disablePhoneNumber === '0' && (
                  <div>
                    <FormInput
                      disabled={formSubmitting}
                      greyBackground={true}
                      labelText="Phone number*"
                      inputType="text"
                      defaultValue=""
                      error={phoneNumberError}
                      onChange={el => {
                        setPhoneNumber(el.currentTarget.value)
                      }}
                    />
                  </div>
                )}
              </div>

              <h2>Business details</h2>
              <div className={classes.flexCont}>
                {rest.disableBusinessName === '0' && (
                  <div>
                    <FormInput
                      disabled={formSubmitting}
                      greyBackground={true}
                      labelText="Business Name*"
                      inputType="text"
                      defaultValue=""
                      error={businessnameError}
                      onChange={el => {
                        setbusinessname(el.currentTarget.value)
                      }}
                    />
                  </div>
                )}
                {rest.disableAbn === '0' && (
                  <div>
                    <FormInput
                      disabled={formSubmitting}
                      greyBackground={true}
                      labelText={`${bizNum}*`}
                      inputType="text"
                      defaultValue=""
                      error={abnError}
                      onChange={el => {
                        setabn(el.currentTarget.value)
                      }}
                    />
                  </div>
                )}
              </div>
              {rest.disableBusinessAddress === '0' && (
                <div className={classes.flexContFull}>
                  <FormInput
                    disabled={formSubmitting}
                    greyBackground={true}
                    labelText="Business Street Address"
                    inputType="text"
                    defaultValue=""
                    error={businessaddressError}
                    onChange={el => {
                      setbusinessaddress(el.currentTarget.value)
                    }}
                  />
                </div>
              )}

              <div className={classes.flexCont}>
                {rest.disablePackage === '0' && (
                  <div>
                    <FormSelect
                      greyBackground={true}
                      noSearch
                      disabled={formSubmitting}
                      defaultValue={packageSelect}
                      onChange={e => {
                        setpackageSelect(e.target.value)
                      }}
                      error={packageSelectError}
                      labelText="Select Package"
                      optionsArray={[
                        'ThriftyGo - Passenger vehicle package',
                        'ThriftyMove - Commercial vehicle package',
                        'Other (specialised or long term rentals)',
                      ].map(type => ({
                        value: type,
                        label: type,
                      }))}
                      placeholder="Select Package"
                    />
                  </div>
                )}
                {rest.disableVehiclesType === '0' && (
                  <div>
                    <FormSelect
                      greyBackground={true}
                      noSearch
                      disabled={formSubmitting}
                      defaultValue={needVehicles}
                      onChange={e => {
                        setneedVehicles(e.target.value)
                      }}
                      error={needVehiclesError}
                      labelText="Please indicate where you need vehicles"
                      optionsArray={['Australia', 'New Zealand'].map(type => ({
                        value: type,
                        label: type,
                      }))}
                      placeholder="Please indicate where you need vehicles"
                    />
                  </div>
                )}
              </div>
              {rest.disableSpendingAnnum === '0' && (
                <div className={classes.flexContFull}>
                  <FormSelect
                    greyBackground={true}
                    noSearch
                    disabled={formSubmitting}
                    defaultValue={spendingannum}
                    onChange={e => {
                      setspendingannum(e.target.value)
                    }}
                    error={spendingannumError}
                    labelText="What is the your estimated spend on rental vehicles per annum?"
                    optionsArray={['$5-$20k', '$20-$50k', '$50-$100k', 'Over $100k'].map(type => ({
                      value: type,
                      label: type,
                    }))}
                    placeholder="What is the your estimated spend on rental vehicles per annum?"
                  />
                </div>
              )}
              {rest.disableContactBy === '0' && (
                <div className={classes.flexCont}>
                  <div>
                    <FormSelect
                      greyBackground={true}
                      noSearch
                      disabled={formSubmitting}
                      defaultValue={contactby}
                      onChange={e => {
                        setcontactby(e.target.value)
                      }}
                      error={contactbyError}
                      labelText="I would like to be contacted by"
                      optionsArray={['Email', 'Phone'].map(type => ({
                        value: type,
                        label: type,
                      }))}
                      placeholder="I would like to be contacted by"
                    />
                  </div>
                </div>
              )}
              <div className={classes.flexContFull}>
                <div style={{ paddingTop: 20 }}>
                  <button onClick={submitForm} className={classes.buttonPrimary}>
                    Submit
                  </button>
                </div>
              </div>

              {formStatus === true && (
                <div
                  style={{
                    border: '1px solid #F7F7F7',
                    boxShadow: '1px 5px 15px rgba(0, 0, 0, 0.15)',
                    borderRadius: 20,
                    padding: '50px 25px',
                    marginTop: 25,
                  }}
                >
                  <div style={{ fontSize: '20px', lineHeight: 1.3 }}>
                    Thank you for for your enquiry, we will be in touch with you shortly.
                  </div>
                  <div style={{ textAlign: 'center', paddingTop: 40 }}>
                    <div
                      style={{
                        backgroundColor: '#11BA22',
                        color: '#fff',
                        borderRadius: '18px',
                        padding: '18px 40px',
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                    >
                      <SVG
                        name="TickCircle"
                        width={16}
                        height={16}
                        colorOne="#11BA22"
                        colorTwo="#fff"
                      />
                      <span style={{ display: 'inline-block', paddingLeft: 5 }}>Success</span>
                    </div>
                  </div>
                </div>
              )}
              {formStatus === false && (
                <div
                  style={{
                    border: '1px solid #F7F7F7',
                    boxShadow: '1px 5px 15px rgba(0, 0, 0, 0.15)',
                    borderRadius: 20,
                    padding: '50px 25px',
                    marginTop: 25,
                  }}
                >
                  <div style={{ fontSize: '20px', lineHeight: 1.3 }}>
                    Something went wrong, please try again later.
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SmallBusinessForm
